import { Component } from '@angular/core';

import { MatomoConsentService } from 'src/app/matomo/matomo-consent.service';

@Component({
  selector: 'app-matomo-consent',
  standalone: false,
  styleUrls: ['./matomo-consent.component.scss'],
  templateUrl: './matomo-consent.component.html',
})
export class MatomoConsentComponent {
  public consentPanelOpen = false;

  constructor(public matomoConsent: MatomoConsentService) {}

  public chooseConsent(accepted: boolean): void {
    this.matomoConsent.setDecision(accepted
      ? 'accepted'
      : 'rejected');
    this.consentPanelOpen = false;
  }
}
